const formatDate = (date) => {
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};

export default formatDate;
